import { Vue, Component, Ref, Prop } from 'vue-property-decorator'

@Component({
    components: {
    }
})
export default class UnitsModalBasicForm extends Vue {
    @Ref() readonly unitsModalBasicForm!: any

    @Prop(String) readonly actionTitle!: string

    show() {
        this.unitsModalBasicForm.show()
    }

    hide() {
        this.unitsModalBasicForm.hide()
    }
}
